import {Controller} from "stimulus"
import DOMUtils from "./../utils/DOMUtils"

export default class extends Controller {

    static targets = [
        "imagesWrap"
    ]

    initialize(){

        let slidesList = ``

        this.$imagesWrap.forEach($image => {
            const $img = $image.querySelector("img")
            const url = $img.getAttribute("src")
            const alt = $img.getAttribute("alt")
            slidesList += `<div class="swiper-slide"><img src="${url}" alt="${alt}"></div>`
        })

        const name = this.data.get("name")

        let templateHTML = `
            <div class="modal modal--swiper" data-modal-name="${name}" data-action="click->modals#close">
                <button type="button" class="modal__cross" 
                    data-modal-name="${name}" 
                    data-target="modals.close"
                    data-action="click->modals#close">
                    <svg width="2.1rem" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#cross--optimized"></use></svg>
                </button>
                <div class="modal__swiper-wrapper" data-controller="swiper" data-gallery-modal-name="${name}">
                    <div
                     data-target="swiper.container"
                     data-swiper-name="${name}"
                     class="swiper-container">
                        <div class="swiper-wrapper">${slidesList}</div>
                    </div>
                    <button class="swiper-button swiper-button-next" data-target="swiper.prevButton">
                        <svg width="1.6rem" viewBox="0 0 15 24" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#carret-right--optimized"></use></svg>
                    </button>
                    <button class="swiper-button swiper-button-prev" data-target="swiper.nextButton">
                        <svg width="1.6rem" viewBox="0 0 15 24" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#carret-left--optimized"></use></svg>
                    </button>
                </div>
            </div>
        `

        this.template = DOMUtils.createTemplate(templateHTML)

        DOMUtils.insertAtTheEnd(document.body, this.template.content.querySelector(".modal"))

    }

    get $imagesWrap(){
        return this.imagesWrapTargets
    }

}